import {
  initialState,
  Actions,
  State,
  EDIT_COMPANY,
  EDIT_COMPANY_SUCCESS,
  EDIT_COMPANY_ERROR,
  RESET_EDIT_COMPANY,
} from '../../types/company/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_COMPANY:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_COMPANY_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_COMPANY_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_COMPANY:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
